import { render, staticRenderFns } from "./CorrectAnswerModal.vue?vue&type=template&id=5e40bdc7&scoped=true&"
import script from "./CorrectAnswerModal.vue?vue&type=script&lang=js&"
export * from "./CorrectAnswerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40bdc7",
  null
  
)

export default component.exports